import { ScreenToParams, spreadScreens } from '@euler/functions/spreadScreens';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { BiChartCategoryPage } from '@euler/playground/bi-charts/BiChartCategoryPage';
import { BiChartGalleryPage } from '@euler/playground/bi-charts/BiChartGalleryPage';
import { BiDashboardsPlaygroundPage } from '@euler/playground/bi-dashboards/BiDashboardsPlayground';
import { BiUploadsPlaygroundPage } from '@euler/playground/bi-uploads/BiUploadsPlayground';
import { BiVisualizationPlaygroundPage } from '@euler/playground/bi-visualization/BiVisualizationPlayground';
import { FileUploadProgressDemo } from '@euler/playground/FileUploadProgress';
import { FreeDrawingWithSkia } from '@euler/playground/FreeDrawingWithSkia';
import { FreeDrawingWithSvg } from '@euler/playground/FreeDrawingWithSvg';
import { KeyboardAvoidingViewWithFlexDemo } from '@euler/playground/keyboard-avoiding/WithFlex';
import { KeyboardAvoidingViewWithScrollViewDemo } from '@euler/playground/keyboard-avoiding/WithScrollView';
import { PlaygroundListScreen } from '@euler/playground/Playground';
import { ScorePlaygroundPage } from '@euler/playground/Score';
import { createStackNavigator } from '@react-navigation/stack';

export type PlaygroundNavParams = ScreenToParams<typeof PlaygroundScreens>;

export const PlaygroundScreens = {
  Main: PlaygroundListScreen,
  Score: ScorePlaygroundPage,
  BiCharts: BiChartGalleryPage,
  BiChartCategory: BiChartCategoryPage,
  BiVisualization: BiVisualizationPlaygroundPage,
  BiDashboards: BiDashboardsPlaygroundPage,
  BiUploads: BiUploadsPlaygroundPage,
  KeyboardAvoidingViewWithScrollViewDemo,
  KeyboardAvoidingViewWithFlexDemo,
  FreeDrawingWithSkia,
  FreeDrawingWithSvg,
  FileUploadProgressDemo,
};

const Stack = createStackNavigator();

export const PlaygroundPage = wrapNavigatorScreen(
  () => {
    return (
      <Stack.Navigator
        screenOptions={{
          headerBackTitleVisible: false,
        }}
      >
        {spreadScreens(Stack.Screen, PlaygroundScreens)}
      </Stack.Navigator>
    );
  },
  { headerShown: false },
);
